import styled, { css } from 'styled-components';

const Box = styled.section`
  position: relative;
  width: 100%;
  margin-bottom: 20px;
  padding: 20px;
  background-color: ${props => props.theme.colors.white};
  border-radius: ${props => props.theme.borderRadius};

  h3 {
    display: inline-flex;
    margin-bottom: 20px;
  }

  ${props =>
    props.overflow &&
    css`
      overflow: hidden;
    `}
`;

const BoxHeader = styled.header`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;

  h3 {
    margin: 0 0 10px;
  }
`;

export { Box, BoxHeader };
